<template>
  <div class="addPatrolPoints">
    <el-dialog title="巡检点信息"
      :visible.sync="$parent.editPoints"
      width="30%">
      <el-form :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        style="width: 80%">
        <el-form-item label="巡检点类型"
          prop="type">
          <el-radio-group v-model="ruleForm.type"
            @change="changeType">
            <el-radio label="REGION">区域巡检</el-radio>
            <el-radio label="DEVICE">设备巡检</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="ruleForm.type == 'REGION' ? '区域名称' : '设备名称'"
          prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="ruleForm.type == 'REGION' ? '区域位置' : '设备位置'"
          prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item :label="ruleForm.type == 'REGION' ? '区域说明' : '设备说明'"
          prop="desc">
          <el-input type="textarea"
            v-model="ruleForm.desc"
            resize="none"
            rows="3"
            maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="$parent.editPoints = false">取 消</el-button>
        <el-button type="primary"
          @click="submitForm('ruleForm')"
          :loading="btnLoading">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        type: "REGION",
        name: "",
        address: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写名称" },
          { whitespace: true, message: "名称不能为空" },
          { min: 5, max: 10, message: "请输入 5 到 10 个字", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请填写位置" },
          { whitespace: true, message: "位置不能为空" },
          { min: 5, max: 10, message: "请输入 5 到 10 个字", trigger: "blur" },
        ],
        desc: [
          { required: true, message: "请填写说明" },
          { whitespace: true, message: "说明不能为空" },
          { min: 5, max: 20, message: "请输入 5 到 20 个字", trigger: "blur" },
        ],

        type: [{ required: true, message: "请选择巡检点类型" }],
      },
      btnLoading: false,
      defaultData: {},
    };
  },
  methods: {
    changeType() {
      this.ruleForm.name = "";
      this.ruleForm.address = "";
      this.ruleForm.desc = "";
      this.$refs["ruleForm"].clearValidate();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return new Promise(async (resolve) => {
            let res = await api.patrolPointOperation({
              id: this.activeItem.id
                ? {
                    entityType: "INSPECTION_POINT",
                    id: this.activeItem.id,
                  }
                : null,
              name: this.ruleForm.name,
              location: this.ruleForm.address,
              pointObjType: this.ruleForm.type,
              remark: this.ruleForm.desc,
              sourceType: "INSPECTION",
            });
            this.btnLoading = true;
            if (res && res.data.code == 200) {
              this.$message.success("提交成功！");
              this.btnLoading = false;
              this.$parent.editPoints = false;
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.$parent.getList();
              }, 1000);
            } else if (res && res.data.code == "00003") {
              this.btnLoading = false;
              this.$message.error(res.data.data);
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.activeItem.id) {
      this.ruleForm.name = this.activeItem.name;
      this.ruleForm.address = this.activeItem.location;
      this.ruleForm.desc = this.activeItem.remark;
      this.ruleForm.type = this.activeItem.type;
    } else {
      this.ruleForm.type = this.$parent.formInline.region;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>